import axios from 'axios';

export interface DeviceScope {
  name: string;
  /** Whatever the resource carries. Absent for a scope with no row of its own, e.g. `offline_access`. */
  displayName?: string;
  description?: string;
  emphasize: boolean;
  required: boolean;
}

export interface DeviceAuthorization {
  userCode: string;
  clientId: string;
  clientName: string;
  clientUrl?: string;
  clientLogoUrl?: string;
  scopes: DeviceScope[];
}

export const DeviceError = {
  Missing: 'DEVICE_CODE_MISSING',
  Unknown: 'DEVICE_CODE_UNKNOWN',
  Refused: 'DEVICE_CODE_REFUSED'
} as const;

/**
 * These endpoints authenticate with the ASP.NET Identity cookie rather than the bearer token the
 * axios interceptor attaches: `IDeviceFlowInteractionService` binds the code to whoever
 * `IUserSession` says is signed in, and that reads the cookie. Same origin as the SPA, so the cookie
 * travels on its own.
 *
 * The posts stay JSON, which is load-bearing and not just a default: it is what makes them
 * unreachable from a cross-site form, and so what stops somebody else's device code being approved
 * from another tab. See `DeviceController` for why no antiforgery token rides along.
 */
export class DeviceApiService {
  public async get(userCode: string): Promise<DeviceAuthorization> {
    const result = await axios.get<DeviceAuthorization>('/api/v1/device', { params: { userCode } });
    return result.data;
  }

  public async approve(userCode: string): Promise<void> {
    await axios.post('/api/v1/device/approve', { userCode });
  }

  public async deny(userCode: string): Promise<void> {
    await axios.post('/api/v1/device/deny', { userCode });
  }
}
